import { HelpCircle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useTranslation } from "react-i18next";

export default function OnboardingHelpPage() {
  const { t } = useTranslation("onboarding");

  const onboardingSteps = [
    {
      title: t("help.step1Title"),
      description: t("help.step1Description"),
    },
    {
      title: t("help.step2Title"),
      description: t("help.step2Description"),
    },
    {
      title: t("help.step3Title"),
      description: t("help.step3Description"),
    },
    {
      title: t("help.step4Title"),
      description: t("help.step4Description"),
    },
  ];

  const faqItems = [
    {
      question: t("help.faq1Question"),
      answer: t("help.faq1Answer"),
    },
    {
      question: t("help.faq2Question"),
      answer: t("help.faq2Answer"),
    },
    {
      question: t("help.faq3Question"),
      answer: t("help.faq3Answer"),
    },
    {
      question: t("help.faq4Question"),
      answer: t("help.faq4Answer"),
    },
  ];

  return (
    <div className="mx-auto max-w-3xl space-y-8 px-4 py-6">
      <div>
        <h1 className="flex items-center gap-2 text-2xl font-bold tracking-tight">
          <HelpCircle className="h-6 w-6 text-primary" />
          {t("help.title")}
        </h1>
        <p className="mt-1 text-muted-foreground">{t("help.subtitle")}</p>
      </div>

      {/* Onboarding Steps */}
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">{t("help.stepsTitle")}</CardTitle>
        </CardHeader>
        <CardContent>
          <ol className="space-y-4">
            {onboardingSteps.map((step, index) => (
              <li key={index} className="flex gap-3">
                <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary/10 text-sm font-semibold text-primary">
                  {index + 1}
                </div>
                <div className="pt-0.5">
                  <p className="font-medium">{step.title}</p>
                  <p className="mt-0.5 text-sm text-muted-foreground">
                    {step.description}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </CardContent>
      </Card>

      {/* FAQ Section */}
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">{t("help.faqTitle")}</CardTitle>
        </CardHeader>
        <CardContent>
          <Accordion type="single" collapsible className="w-full">
            {faqItems.map((item, index) => (
              <AccordionItem key={index} value={`faq-${index}`}>
                <AccordionTrigger className="text-left">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </CardContent>
      </Card>
    </div>
  );
}
